"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventEmitter = (function () {
    function EventEmitter() {
        this.events = {};
    }
    EventEmitter.prototype.on = function (event, listener) {
        this.events[event] = this.events[event] || [];
        this.events[event].push(listener);
        return this;
    };
    EventEmitter.prototype.once = function (event, listener) {
        var _this = this;
        var fn = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.off(event, fn);
            listener.apply(_this, args);
        };
        fn.listener = listener;
        this.on(event, fn);
        return this;
    };
    EventEmitter.prototype.off = function (event, listener) {
        var listeners = this.events[event];
        if (listeners !== undefined) {
            for (var j = 0; j < listeners.length; j += 1) {
                if (listeners[j] === listener || listeners[j].listener === listener) {
                    listeners.splice(j, 1);
                    break;
                }
            }
            if (listeners.length === 0) {
                this.removeAllListeners(event);
            }
        }
        return this;
    };
    EventEmitter.prototype.removeAllListeners = function (event) {
        try {
            delete this.events[event];
        }
        catch (e) {
            return;
        }
        return this;
    };
    EventEmitter.prototype.listeners = function (event) {
        try {
            return this.events[event];
        }
        catch (e) {
            return;
        }
    };
    EventEmitter.prototype.emit = function (command, data) {
        var args = [].slice.call(arguments, 0);
        var event = args.shift();
        var listeners = this.events[event];
        if (listeners !== undefined) {
            listeners = listeners.slice(0);
            var len = listeners.length;
            for (var i = 0; i < len; i += 1) {
                listeners[i].apply(this, args);
            }
        }
        return this;
    };
    return EventEmitter;
}());
exports.EventEmitter = EventEmitter;
